import en from './en'
import cn from './cn'
import pt from './pt_br'

export default {
    en,
    cn,
    pt
}